export default "__VITE_PUBLIC_ASSET__52402d61__"